/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface AllShipmentsTimeSeriesBucket
 */
export interface AllShipmentsTimeSeriesBucket {
  /**
   *
   * @type {string}
   * @memberof AllShipmentsTimeSeriesBucket
   */
  label: string;
  /**
   *
   * @type {number}
   * @memberof AllShipmentsTimeSeriesBucket
   */
  quotedCount: number;
  /**
   *
   * @type {number}
   * @memberof AllShipmentsTimeSeriesBucket
   */
  bookedCount: number;
  /**
   *
   * @type {number}
   * @memberof AllShipmentsTimeSeriesBucket
   */
  moneyIn: number;
  /**
   *
   * @type {number}
   * @memberof AllShipmentsTimeSeriesBucket
   */
  moneyOut: number;
  /**
   *
   * @type {number}
   * @memberof AllShipmentsTimeSeriesBucket
   */
  profit: number;
}

/**
 * Check if a given object implements the AllShipmentsTimeSeriesBucket interface.
 */
export function instanceOfAllShipmentsTimeSeriesBucket(
  value: object,
): value is AllShipmentsTimeSeriesBucket {
  if (!("label" in value) || value["label"] === undefined) return false;
  if (!("quotedCount" in value) || value["quotedCount"] === undefined)
    return false;
  if (!("bookedCount" in value) || value["bookedCount"] === undefined)
    return false;
  if (!("moneyIn" in value) || value["moneyIn"] === undefined) return false;
  if (!("moneyOut" in value) || value["moneyOut"] === undefined) return false;
  if (!("profit" in value) || value["profit"] === undefined) return false;
  return true;
}

export function AllShipmentsTimeSeriesBucketFromJSON(
  json: any,
): AllShipmentsTimeSeriesBucket {
  return AllShipmentsTimeSeriesBucketFromJSONTyped(json, false);
}

export function AllShipmentsTimeSeriesBucketFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AllShipmentsTimeSeriesBucket {
  if (json == null) {
    return json;
  }
  return {
    label: json["label"],
    quotedCount: json["quotedCount"],
    bookedCount: json["bookedCount"],
    moneyIn: json["moneyIn"],
    moneyOut: json["moneyOut"],
    profit: json["profit"],
  };
}

export function AllShipmentsTimeSeriesBucketToJSON(
  json: any,
): AllShipmentsTimeSeriesBucket {
  return AllShipmentsTimeSeriesBucketToJSONTyped(json, false);
}

export function AllShipmentsTimeSeriesBucketToJSONTyped(
  value?: AllShipmentsTimeSeriesBucket | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    label: value["label"],
    quotedCount: value["quotedCount"],
    bookedCount: value["bookedCount"],
    moneyIn: value["moneyIn"],
    moneyOut: value["moneyOut"],
    profit: value["profit"],
  };
}
